module.exports = __webpack_public_path__ + "assets/align-center-active.5362a631.svg";